import axios from 'axios';
import { getJson, addExtraInfos, convertToUrlParams } from './utils';

async function get(url, config = {}, AddSessionParams = false) {
  try {
    if(AddSessionParams){
      config.params = await addExtraInfos(config.params);
    }
    return axios.get(url, config);
  } catch (err) {
    return Promise.reject(err);
  }
}

async function post(url, data, config = {}, isForm = false) {
  try {
    let datas = data;

    if (isForm) {
      if (!config.headers) {
        config.headers = {};
      }
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      const extraInfos = await addExtraInfos(data);
      datas = convertToUrlParams(extraInfos);
    }

    const response = await axios.post(url, datas, config);
    response.data = getJson(response.data);
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
}

function deleteQuery(url, config) {
  return axios.delete(url, config);
}

function put(url, data, config) {
  return axios.put(url, data, config);
}

// deprecated method - use get() method instead of
// config.params = { ...config.params, ...data };
// return get(url, config, true);
async function getQuery(url, data, config) {
  try {
    data = await addExtraInfos(data);
    url += '?' + convertToUrlParams(data);
    return axios.get(url, config);
  } catch (error) {
    return Promise.reject(error);
  }
}

// deprecated method - use get() method instead of
// config.params = { ...config.params, ...data };
// return get(url, config, false);
async function getData(url, data, config) {
  try {
    url += '?' + convertToUrlParams(data);
    return axios.get(url, config);
  } catch (error) {
    return Promise.reject(error);
  }
}

export { get, post, deleteQuery, put, getQuery, getData };
